import { del, getAuthenticatedRequestConfig } from '../client'
import { removeDeviceTokenSerializer } from '../../serializers/removeDeviceTokenSerializer'

export const removeDeviceTokenResource = (params = {}) => {
  const { token } = params

  return del(`/v1/subscribers/${token}`, { ...params, token })
    .then((response) => removeDeviceTokenSerializer(response))
    .catch((error) => Promise.reject(error))
}

export const removeAuthenticateDeviceTokenResource = (
  baseURL,
  authToken,
  authHeader,
  authScheme,
  params = {}
) => {
  const requestConfig = getAuthenticatedRequestConfig(
    baseURL,
    authToken,
    authHeader,
    authScheme,
    params
  )

  return removeDeviceTokenResource(requestConfig)
}

export default removeDeviceTokenResource
